import { render, staticRenderFns } from "./WorkingGroupView.vue?vue&type=template&id=8f1142cc&"
import script from "./WorkingGroupView.vue?vue&type=script&lang=js&"
export * from "./WorkingGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports